export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
            关于我们
          </h2>
          <p className="text-sm text-foreground-500">了解向日葵视频的使命与愿景</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/70">
            <div className="flex flex-col md:flex-row gap-8 md:gap-10 items-start">
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-primary-500 flex items-center justify-center shrink-0">
                <i className="ri-sun-fill text-background-50 text-2xl md:text-3xl"></i>
              </div>
              <div className="flex-1">
                <h3 className="text-lg md:text-xl font-bold font-heading text-foreground-900 mb-4">
                  向日葵视频 — 水果植物视频平台的聚合导航入口
                </h3>
                <div className="space-y-3 text-sm md:text-base text-foreground-600 leading-relaxed">
                  <p>
                    向日葵视频成立于2023年，是国内领先的水果植物主题视频平台聚合导航站点。我们以"发现好内容，连接好平台"为核心理念，致力于为用户整理收录包括香蕉视频、西瓜视频免费专区、蜜桃视频、樱花视频等在内的优质水果视频在线平台资源。
                  </p>
                  <p>
                    平台聚合的内容涵盖热门影视剧集、综艺动漫、自然人文纪录片以及创意生活短视频，覆盖用户日常娱乐观影的多元需求。我们坚持"精选而非海量"的收录原则，每一家水果视频在线平台均经过编辑人工评测后收录。
                  </p>
                  <p>
                    未来，向日葵视频将继续拓展植物视频平台资源库，持续优化导航体验，为用户提供更加便捷、安全、高效的水果视频在线入口服务，让每一位访问者都能轻松找到心仪的观影平台。
                  </p>
                </div>
                <div className="flex flex-wrap gap-4 mt-6">
                  <div className="flex items-center gap-2 text-sm text-foreground-500">
                    <i className="ri-checkbox-circle-fill text-accent-500"></i>
                    <span>收录平台 50+</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-foreground-500">
                    <i className="ri-checkbox-circle-fill text-accent-500"></i>
                    <span>月均更新 200+ 条</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-foreground-500">
                    <i className="ri-checkbox-circle-fill text-accent-500"></i>
                    <span>编辑团队 15 人</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}